<div class="container-fluid">
    <div class="row header-container">
        <div class="col-12 p-0">
            <banner></banner>
        </div>
        <div class="col-sm-12">
            <header>
                <div class="row header-background">
                    <div class="col-sm-12 col-md-4">
                        <h1 class="mb-0"><a href="/"><img src="../../../assets/logo.png" alt="Comply by Edulink" title="Comply by Edulink"/></a></h1>
                    </div>
                    <nav aria-label="Utility navigation" class="col-md-8 d-none d-lg-flex justify-content-end align-items-center">
                        <ul class="float-end mb-0">
                            <li>
                                <a class="nav-link" href="https://edulink.freshdesk.com/support/home" target="_blank">Support</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
        </div>
    </div>
    <main class="row">
        <div class="col-sm-12">
            <div class="container">
                <ui-view name="content"></ui-view>
            </div>
        </div>
    </main>
</div>
